<template>
    <q-card flat v-bind="attrs">
        <q-card-section class="q-pt-none q-pl-sm" >
            <div class="row justify-end q-pa-sm print-hide">About these data <q-icon name="help_outline" class="q-pl-sm pointer" size="xs"  @click="dataConsiderations['birds'].model = !dataConsiderations['birds'].model"/></div>
            <div class="q-pl-sm q-pr-sm  text-caption text-left">This pane includes bird species that use coastal habitats as part of their yearly migratory journey. Some of these species may also utilize offshore habitats; check the “Offshore birds” pane for data offshore.</div>
            <div class="text-caption q-pa-sm">NOTE: This section does not include for all birds found in coastal habitats. See 'About these data' for more information.</div>

            <div v-if="data[spLayer]" id="birdPane">
                <div class="row items-center q-pa-sm print-hide">
                    <div class="col-2">Group<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs[activeGroup.value].model = !infoDialogs[activeGroup.value].model" aria-label="Coastal bird group data help"/>:</div>
                    <div class="col-6 q-pa-sm">
                          <q-select class="q-ml-sm" dense outlined :options="spGroupChoices" v-model="activeGroup" ></q-select>
                     </div>
                </div>
                <div class="text-h5" >{{ activeGroup.label }}</div>
                <div class="text-h6 q-mt-md row text-uppercase" ><span class="text-bold">Diversity<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['diversity'].model = !infoDialogs['diversity'].model" aria-label="Bird diversity data help"/></span></div>
                <q-card flat class="q-pa-xs">
                    <div class="row justify-start items-center">
                        <div class="col-6 text-center items-center text-caption">           
                            <div class="row q-mt-sm"><div class="col-3 text-h5 text-bold">{{ dialVals.numSpp }}</div><div class="col-9 text-left">species estimated within this area (abundance >50 percentile)</div></div>
                            <div class="row q-mt-sm"><div class="col-3 text-h5 text-bold">{{ dialVals.numGTVal }}</div><div class="col-9 text-left">species at high abundance levels (>75 percentile)</div></div>        
                        </div>

                        <div class="col-6 text-center items-center text-caption" v-if="activeGroup.value == 'all' && dialVals.numSpp >0">
                            <div class="row">Relative to the {{ ecos[data['majEcoregion']] }} ecoregion: 
                                <q-btn v-if="season.value == 'ALL'" dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['birdDial'].model = !infoDialogs['birdDial'].model" aria-label="Bird dial help"/> 
                             </div>
                            <div class="text-center q-ml-lg dial-container"><Dial  divName="birdDial"  :dialConfig="zDialConfig" :colors="dialColors" :dialVal="dialVals.dialVal" /></div>
                            <div class="text-center">(
                                <span v-if="dialVals.dialVal >=2.5">&ge;</span>
                                <span v-if="dialVals.dialVal <=-2.5">&le;</span>
                                {{ Math.round(dialVals.dialVal *10 ) /10}} SD)
                            </div>
                        </div>
                    </div>
                </q-card>

                <div class="text-h6 q-mt-md row text-uppercase" ><span class="text-bold">Abundance<q-btn dense size="xs" flat class="gray q-mb-md" icon="help_outline" @click="infoDialogs['density'].model = !infoDialogs['density'].model" aria-label="Bird density data help"/></span></div>
                <div class="tab-container shadow-1">
                    <q-tabs v-model="birdTabs" class="shadow-1 q-ml-xs q-mr-xs">
                        <q-tab label="Annual Maximum"  @click="loadDataByID(spLayer, version), clearMapStyle()" name="density"></q-tab>
                        <q-tab label="Monthly" @click="loadDataByID(spTimeLayer, version), clearMapStyle()" name="time" ></q-tab>
                    </q-tabs>
                    <q-tab-panels dense v-model="birdTabs" class="outlined">
                        <q-tab-panel name="density"  class="q-pa-xs">   
                            <q-card flat class="q-pl-sm temp-card">
                                <div :style="{'min-height' : '25px'}" class="q-mt-sm">
                                    <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                        <div class="col-2 text-secondary">
                                            <span class="text-bold ">DATA ON THE MAP</span>:
                                        </div>
                                        <div class="col-6">
                                            <q-select
                                                :hide-bottom-space="true"
                                                dense
                                                class="secondary-dropdown q-ma-xs q-pa-xs"
                                                :options="spChoices"
                                                map-options
                                                v-model="activeSpCode"
                                                @update:model-value="rowClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                                hint="Select a species or click below"
                                                >
                                                <template v-slot:selected-item="scope">
                                                    <div class="text-bold text-secondary">
                                                        {{ scope.opt.label }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-3">
                                            <q-select 
                                                :hide-bottom-space="true"
                                                dense 
                                                class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                                :options="layerTypes" 
                                                v-model="layerType"  
                                                @update:model-value="layerTypeChange"
                                                :hint="notSelectedTypes"
                                                >
                                                <template v-slot:selected-item="scope">
                                                    <div class="text-bold text-secondary">
                                                        {{ scope.opt.label }}
                                                    </div>
                                                </template>
                                            </q-select>
                                        </div>
                                        <div class="col-1 justify-end items-end">
                                            <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                        </div>     
                                    </div>
                                </div>
                      
                                <div class="row bar-header justify-center text-caption text-bold q-pr-sm">
                                    <div class="col-8 text-center">Species</div>
                                    <div class="col-2 text-center q-pl-lg">
                                        % High
                                        <q-btn dense size="xs" flat class="gray" icon="help_outline" @click="infoDialogs['pHigh'].model = !infoDialogs['pHigh'].model" aria-label="High threshold help"/>
                                    </div>
                                    <div class="col-1 text-center q-pl-sm">Species Spotlight</div>
                                </div>
                                <div class="bar-rows-container q-pr-sm"                                 
                                    tabindex="0" 
                                    role="region" 
                                    aria-label="Scrollable bar rows"
                                >
                                    <div v-for="barCat, i in barData" 
                                        @click="rowClick(barCat[0].spID, barCat[0].sp)"
                                        class="row pointer bar-row justify-center"
                                        :class="mapStyleInfo['attr'] === barCat[0].spID ? 'highlight' : ''">
                                        <div class="col-10">
                                            <StackedBar 
                                                :data="barCat" 
                                                :divName="barName(i)" 
                                                categoryProp="category" 
                                                barName="sp" 
                                                valueProp="value" 
                                                class="q-mt-none" 
                                                :xAxisTicks="false"
                                                :categoryColors="barColors"
                                                :topMargin="0"                                       
                                            />
                                        </div>

                                        <!-- the % high + very high is repeated for each sp obj in the array, so just take the first -->
                                        <div class="col-1 text-caption">{{ barCat[0].percHighVH }}</div>
                                        <div    class="col-1 text-caption" @click.stop="goToSpSpotlight(barCat[0].spID)">
                                            <q-icon v-if="Object.keys(Habitats).includes(barCat[0].spID)" name="search" class="circle" size="xs" :style="{'background-color' : '#008472'}" color="white"/>
                                            <q-tooltip v-if="Object.keys(Habitats).includes(barCat[0].spID)">Go to the species spotlight section for {{barCat[0].sp}}</q-tooltip>
                                        </div>                                    
                                    </div>
                                </div>
                            </q-card>             
                        </q-tab-panel>
                        <q-tab-panel name="time"  class="q-pa-xs" >
                            <div :style="{'min-height' : '25px'}" class="q-mt-sm">
                                <div class="row text-caption items-center q-mb-sm q-pl-sm q-mr-sm  map-descr-row" >
                                    <div class="col-2 text-secondary">
                                        <span class="text-bold ">DATA ON THE MAP</span>:
                                    </div>
                                    <div class="col-4">

                                        <q-select
                                            :hide-bottom-space="true"
                                            dense
                                            class="secondary-dropdown q-ma-xs q-pa-xs"
                                            :options="spChoices"
                                            map-options
                                            v-model="activeSpCode"
                                            @update:model-value="tableCellClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            hint="Select a species or click below"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-2">
                                        <q-select 
                                            v-if="activeSpCode.value"
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="months" 
                                            v-model="month"  
                                            @update:model-value="monthChange"
                                            hint="Month"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-3">
                                        <q-select 
                                            v-if="activeSpCode.value && month"
                                            :hide-bottom-space="true"
                                            dense 
                                            class="secondary-dropdown q-ma-xs q-pl-xs q-pr-xs"  
                                            :options="monthLayerTypes" 
                                            v-model="monthLayerType"  
                                            @update:model-value="tableCellClick(activeSpCode.value, AllCodes[activeSpCode.value])"
                                            :hint="notSelectedMonthTypes"
                                            >
                                            <template v-slot:selected-item="scope">
                                                <div class="text-bold text-secondary">
                                                    {{ scope.opt.label }}
                                                </div>
                                            </template>
                                        </q-select>
                                    </div>
                                    <div class="col-1 justify-end items-end">
                                        <q-icon name="cancel" class="pointer text-end" size="sm" color="grey" @click="clearMap()"/>
                                    </div>     
                                </div>
                            </div>
                            
                            <div v-if="data[spTimeLayer]" class="time-table-container">
                                <Table 
                                    :version="version"
                                    :rows="birdMonthData" 
                                    :columns="columns"
                                    title=""
                                    :expandRows="false"
                                    :mapStyle="true"
                                    :mapStops="stops['spp_90maxW50']"
                                    :mapClassNames="legendColorStopNames"
                                    :cellColors="tableCellColors"
                                    :labelCells="false"
                                    :mapLayer=spTimeLayer
                                    :mapLegendTitles="birdMonthLegendTitles"
                                    :selSp="activeSpCode ? activeSpCode : null"
                                    :selMonth="month ? month : null"
                                    @cellClick="tableClickEmitFunc"
                                    :dqStops="dqStops['quality_4cls']"
                                    :dqClassNames="qualityClasses"
                                ></Table>
                                <div class="text-caption" >
                                    NOTE: Data for Arctic tern and Red-necked Phalarope are only available on an annual basis.
                                </div>
                            </div> 
                            <div v-else class="row justify-center">
                                <q-spinner size="lg"></q-spinner>
                            </div>

                        </q-tab-panel>
                    </q-tab-panels>
                </div>
                <div class="row text-center justify-center q-mt-md q-mb-sm">
                    <div class="col-2" :style="{'background-color' : barColors['Very High'], 'color' :'white'}">Very High<br/>(>90)</div>
                    <div class="col-2" :style="{'background-color' : barColors['High']}">High<br/>(>75)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Medium']}">Medium<br/>(>1)</div>
                    <div class="col-2" :style="{'background-color' : barColors['Low']}">Low<br/>(>0)</div>
                    <div class="col-2" :style="{'background-color' : barColors['No Data']}">No Data</div>
                </div>

                <div v-if="CoastalBirdGroups_NoData[activeGroup.value].length >0" class="text-caption">
                    Data is not available for the following bird species in the <span class="text-bold">{{ activeGroup.label }}</span> group: 
                    <span  v-for="sp in CoastalBirdGroups_NoData[activeGroup.value]" >
                        {{ AllCodes[sp] }}, 
                    </span> 
                </div>
            </div>
            <div v-else class="row justify-center">
                <q-spinner size="lg"></q-spinner>
            </div>
        </q-card-section>
    </q-card>
    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
    <div v-for="(infoObj, name) in dataConsiderations" :key="name" >
      <q-dialog v-model="infoObj.model">
          <q-card>
          <q-card-section>
              <CoastalDataConsiderations :groupsToShow="name" />
          </q-card-section>
          <q-card-actions align="right">
              <q-btn flat label="OK" color="primary" @click="infoObj.model = false" />
          </q-card-actions>
          </q-card>
      </q-dialog>
  </div>
</template>
<script setup lang="ts">
import { toRefs, ref, onMounted, onUnmounted, computed, useAttrs } from "vue";
import { QTableColumn } from 'quasar';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { stops, dqStops } from "../assets/ColorStops.json"
import Dial from "./Dial.vue";
import StackedBar from "./StackedBar.vue";
import Table from "./Table.vue";
import InfoDialog from "./InfoDialog.vue";
import { CoastalBirdGroups } from "../assets/CoastalBirdGroups.json"
import { CoastalBirdGroups_NoData } from "../assets/CoastalBirdGroups_NoData.json"
import { CoastalBirdMeanSDs } from "../assets/MeanSDs.json"
import { AllCodes } from "../assets/SppCodesToNames.json"
import { Habitats  } from "../assets/SpSpotText.json"
import { useRouter } from 'vue-router'
import CoastalDataConsiderations from "./CoastalDataConsiderations.vue";

const router = useRouter()
const { setActiveSpSpotlight, processDialData, processStackedBarData, processMonthData, ecos, loadDataByID, styleMap, setLegend, mapStyleInfo, clearMapStyle, activeLayerID, setDataQuality, getData, userPolygon, setActiveSpGroups, activeSpGroups } = useMapItems()
const {  arrayFindObjectByProp } = useHelpers();
const attrs = useAttrs();

const props = defineProps({
    data: { type: Object },
    version: {type: Number}
})

const {  data, version } = toRefs(props)
const ecoregion = data.value['majEcoregion']

const dialVals = computed(() =>{
    // the 2nd to last value is the threshold for "spp supported by this site"
    // the last value (90) is used as the threshold for defining very high abundance.  # of sp with presence >= that value in AOI
    const val = processDialData(version, data, spLayer, activeGroup, ecoregion, season, CoastalBirdGroups, CoastalBirdMeanSDs, 50, 75)
    return val
})

const barData = computed(() =>{
    const percHVHVals = [75, 90] // values that are used to calculate the % high & very high abundance
    let barData = processStackedBarData(version, data, spLayer, activeGroup, CoastalBirdGroups, AllCodes, barCategories, barSortOrder, percHVHVals)
    if (barData == "need data"){ 
        // this can happen if a group is selected then a share link is used.  When returning, not all
        // groups are necessarily in the processedData object, so need to fetch the cellData again
        getData(userPolygon.value.polyID, 1, true)
        barData =  processStackedBarData(version, data, spLayer, activeGroup, CoastalBirdGroups, AllCodes, barCategories, barSortOrder, percHVHVals)
    }
    return barData 
})

const birdMonthData=  computed(() =>{
    const sortOrder = getSpIDs(barData.value)
    const monthData = processMonthData(spTimeLayer, version, activeGroup, data, CoastalBirdGroups, AllCodes, sortOrder)
    return monthData
})

const barSortOrder = ["Very High", "High", "Medium", "Low",  "No Data"]
const barCategories = {
    "-9" : "No Data",
    "0" : "Low", 
    "50" : "Medium",
    "75" :"High",
    "90" :"Very High"
}

const activeGroup = computed({
    get: () => {
        const gr = activeSpGroups.value['birds']
        const grObj = arrayFindObjectByProp(spGroupChoices.value, "value", gr)
        return grObj
    },
    set: (value) => {
        setActiveSpGroups("birds", value.value)
    }
});


// if spLayer is a computed property, then the barGraphs computed property
// updates twice on season change.  Better for spLayer to be updated directly when season is
const spLayer = ref("COASTAL_BIRD_YEAR")
const spTimeLayer = ref("COASTAL_BIRD_MONTH")

const season = ref({value: "ALL", label: "All Year"})

const spGroupChoices = computed(() =>{
    const choices =[]
    for (const [key, value] of Object.entries(CoastalBirdGroups)) {
        choices.push({value: key, label: spGroupPrettyNames[key]})
    }
    return choices
})
const dialColors = {'color1' :'#F1FDFC', 'color2' : '#1D8177', 'color3' :'#02524a'}
const barColors ={
    "Very High" : "#830C5D",
    "High" : "#F16DC6",
    "Medium" : "#EEB3DA",
    "Low"  : "#F7E8F2",
    "No Data" : "#a1a1a1"
}

const spGroupPrettyNames ={
    "all" : "All Coastal Birds",
    "alcids": "Alcids or Auks",
    "esa": "ESA listed species",
    "state": "State listed as endangered",
    "ambcchigh": "High conservation value by AMBCC",
    "nersgcnhigh": "High conservation value by NE RSGCN",
    "cormorants": "Cormorants",
    "dabbling_ducks": "Dabbling Ducks",
    "gannets": "Gannets",
    "gulls_allies": "Gulls & Allies",
    "jaegers_skuas": "Jaegers & Skuas",
    "largewadingbirds": "Large Wading Birds",
    "landbasedshorebird": "Land-based shorebirds",
    "loons_grebes": "Loons & Grebes",
    "passerines": "Passerines & other small landbirds",
    "pelicans": "Pelicans",
    "petrels_shearwaters": "Petrels & Shearwaters",
    "stormpetrels": "Storm Petrels",
    "pharalopes": "Pharalopes",
    "seaducks_divingducks": "Seaducks & Diving Ducks",
    "terns_skimmers": "Terns & Skimmers",
    "collision": "High collision sensitivity w. offshore wind",
    "displacement": "High displacement sensitivity w. offshore wind"
}

const legendColorStopNames ={
    '-9' : "No Data",
    "0" : "Low",
    "50" : "Medium",
    "75" : "High", 
    "90" : "Very High"
}

const zDialConfig = computed(() =>{
    return {
        minVal: -2.5,   //dial min value
        maxVal: 2.5,    //dial max value
        majorTicks: 35, //this is the number of color gradations
        ticks: [-2, -1, 0, 1, 2],  //numberical label
        labels: ["Far Less", "Less", "Avg", "More", "Far More"],  //optional array of pretty names that will replace numerical.  Must be in same order
        labelSize: 10  //px size of the labels
    }
})

const columns: QTableColumn[] = [
    { name: 'name', required: true, label: 'Species', align: 'left',field: 'name', sortable: true, style: 'padding-left: 3px; width: 55px; max-width: 55px;'  },
    { name: 'Jan', align: 'center', label: 'Jan', field: 'Jan', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;'  },
    { name: 'Feb', align: 'center', label: 'Feb', field: 'Feb', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Mar', align: 'center', label: 'Mar', field: 'Mar', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Apr', align: 'center', label: 'Apr', field: 'Apr', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'May', align: 'center', label: 'May', field: 'May', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jun', align: 'center', label: 'Jun', field: 'Jun', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Jul', align: 'center', label: 'Jul', field: 'Jul', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Aug', align: 'center', label: 'Aug', field: 'Aug', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Sep', align: 'center', label: 'Sep', field: 'Sep', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Oct', align: 'center', label: 'Oct', field: 'Oct', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Nov', align: 'center', label: 'Nov', field: 'Nov', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
    { name: 'Dec', align: 'center', label: 'Dec', field: 'Dec', sortable: true, style: 'padding: 0px 0px 0px 0px; width: 29px; max-width: 29px;' },
 ]
const tableCellColors ={
    "90" : "#830C5D",
    "75" : "#F16DC6",
    "50" : "#EEB3DA",
    "0"  : "#F7E8F2",
    "-9" : "#a1a1a1"
}
const barName = (i) =>{
    return "birdBar" + i
}

const birdTabs = ref('density')
const birdMonthLegendTitles = computed(() =>{
    // used in the map legend-- needed so that year is updated
    // when you click on a table column
    const titles = {
        "Jan" : "density (Jan)",
        "Feb" : "density (Feb)",
        "Mar" : "density (Mar)",
        "Apr" : "density (Apr)",
        "May" : "density (May)",
        "Jun" : "density (Jun)",
        "Jul" : "density (Jul)",
        "Aug" : "density (Aug)",
        "Sep" : "density (Sep)",
        "Oct" : "density (Oct)",
        "Nov" : "density (Nov)",
        "Dec" : "density (Dec)",

    }
    return titles
})

const layerType = ref({value: "density", label : "Density"})
const layerTypes = [
    {label : "Density", value: "density"}, 
]
const notSelectedTypes = computed(() =>{
    let notSel = ""
    for (const typeObj of layerTypes){
        if (typeObj.value != layerType.value.value){
            notSel += `${typeObj.label}, `
        }
    }
    return notSel.slice(0, -2);
})

const activeSpCode =ref({value: "", label: ""})
const spChoices  = computed(() =>{
    const choices =[]
    CoastalBirdGroups[activeGroup.value.value].forEach((sp) =>{
        choices.push({value: sp, label: AllCodes[sp]})
    })
    console.log(choices)
    return choices
});

const clearMap = () =>{

    clearMapStyle();
    activeSpCode.value = null;
    month.value = null
}

const layerTypeChange = () =>{
    const spID = mapStyleInfo.value['attr']
    let attr = spID
    if(spID.endsWith("_S")){
        attr = spID.replace("_S", "")
    }
    const sp = AllCodes[attr]
    rowClick(attr, sp)
}


// setup data for monthly data map control dropdowns & bind to table
const monthLayerType = ref({value: "density", label : "Density"})
const monthLayerTypes = [
    {label : "Density", value: "density"}, 
]

const notSelectedMonthTypes = computed(() =>{
    let notSel = ""
    for (const typeObj of monthLayerTypes){
        if (typeObj.value != monthLayerType.value.value){
            notSel += `${typeObj.label}, `
        }
    }
    return notSel.slice(0, -2);
})

const tableClickEmitFunc = (e) =>{
    // console.log(e)
    const spID = e.sp;
    month.value = arrayFindObjectByProp(months, "value", e.month)
    tableCellClick(spID, AllCodes[spID])

}
const tableCellClick = (spID, sp) =>{
    if (typeof spID === 'object'){
        activeSpCode.value= spID
    }
    else{
        activeSpCode.value = {value: spID, label: sp};
    }

    let lyrID =activeLayerID.value
    if (activeSpCode.value && month.value){
        if (monthLayerType.value.value == 'density'){
            if (activeLayerID.value.includes("QUALITY")){
                lyrID = activeLayerID.value.replace("_QUALITY", "")
                setDataQuality(false)
                loadDataByID(lyrID, version.value)
            }
            let attr = spID + "_" + month.value.value
            styleMap(lyrID, attr, 'categorical', stops['spp_90maxW50'], legendColorStopNames) 
            setLegend(sp + " (" +month.value.label+"): Estimated Density", stops['spp_90maxW50'], legendColorStopNames)
        }

        else if (monthLayerType.value.value == 'quality'){
            if (!activeLayerID.value.includes("QUALITY")){
                lyrID = activeLayerID.value + "_QUALITY"
                setDataQuality(true)
                loadDataByID(lyrID, version.value)
            }

            let attr = spID + "_" + month.value.value
            styleMap(lyrID, attr, 'categorical',  dqStops['quality_4cls'], qualityClasses)
            setLegend(sp + " (" + month.value.label + "): Data Confidence", dqStops['quality_4cls'],  qualityClasses)
        }
        else{lyrID = activeLayerID.value}
    }
}

const month = ref({value: "M01",  label: "Jan"})
const monthChange = (e) =>{
    // console.log(e)
    month.value = arrayFindObjectByProp(months, "value", e.value)
    tableCellClick(activeSpCode.value.value, AllCodes[activeSpCode.value.value])
}

const months = [
    {value: "M01",  label: "Jan"},
    {value: "M02",  label: "Feb"},
    {value: "M03",  label: "Mar"},
    {value: "M04",  label: "Apr"},
    {value: "M05",  label: "May"},
    {value: "M06",  label: "Jun"},
    {value: "M07",  label: "Jul"},
    {value: "M08",  label: "Aug"},
    {value: "M09",  label: "Sep"},
    {value: "M10",  label: "Oct"},
    {value: "M11",  label: "Nov"},
    {value: "M12",  label: "Dec"},
]
const qualityClasses = {
    "-9" : "No Data",
    "1" : "Highest",
    "2" : "Medium",
    "3" : "Low",
    "4" : "Lowest"
}

const rowClick = (spID, sp) =>{
    activeSpCode.value = spID;
    let lyrID =activeLayerID.value
    if (layerType.value.value == 'density'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        styleMap(lyrID, spID, 'categorical', stops['spp_90maxW50'], legendColorStopNames) 
        setLegend(sp + ' Estimated Density (Annual max.)', stops['spp_90maxW50'], legendColorStopNames)
    }
    else if (layerType.value.value == 'sightings'){
        if (activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value.replace("_QUALITY", "")
            setDataQuality(false)
            loadDataByID(lyrID, version.value)
        }
        const attr = spID + "_S"
        const names = {
            "1" : "Sighting",
            "0" : "No Sighting"
        }
        styleMap(lyrID, attr, 'categorical', stops['sighting'], names), 
        setLegend(sp + ' Sightings', stops['sighting'], names)
    }


    else if (layerType.value.value == 'quality'){
        if (!activeLayerID.value.includes("QUALITY")){
            lyrID = activeLayerID.value + "_QUALITY"
            setDataQuality(true)
            loadDataByID(lyrID, version.value)
        }

        let attr = spID
        styleMap(lyrID, attr, 'categorical',  dqStops['quality_4cls'], qualityClasses)
        setLegend(sp + ':  % of months with high confidence', dqStops['quality_4cls'],  qualityClasses)
    }
    else{lyrID = activeLayerID.value}
}

const getSpIDs = (data) => {
    return data.map(subArray => subArray[0].spID);
}

const goToSpSpotlight = (sp) =>{
  let s
  // if the sp is being passed from monthgly data, just get the root of the sp
  if (sp.includes("_M")){
    s = sp.slice(0, 4)
  }
  else{
    s = sp
  }
  setActiveSpSpotlight(s)
  router.push('/spSpotlight')
}
const dataConsiderations = ref({
    birds : {
        model:false
    }

})
const infoDialogs = ref({
  birdMonths: {
    pName: "Monthly Data",
    model: false,
    text: "Please note that monthly data is only available for a subset of bird species."
  },
  diversity: {
    pName: "Diversty Data",
    model: false,
    text: "Diversity values show the number of bird species that have estimated density values beyond the 'Very High' threshold, or above the 90 percentile, in the area of interest. Estimated density values originate from eBird data, and the analysis performed by Cornell University. <div class='q-pt-sm'>The dial graphic displaying diversity relative to the ecoregion is only available for the 'All Birds' group.</div>"
  },
  density:{
    pName: "Estimated Density Data",
    model: false,
    text: "Estimated abundance values originate from eBird data from Cornell University.  Threshold values are calculated by species across time. Yearly values are maximum values across all months."
  },    
  all: {
    pName: "All Coastal Birds",
    model: false,
    text: "This group includes all species of birds that have coastal data available."
  },
  esa: {
    pName: "ESA listed species",
    model: false,
    text: "This group includes bird species that are listed as Endangered under the Endangered Species Act (ESA). It includes Roseate Tern. Note that not all ESA-listed species have data available. "
  },
  state: {
    pName: "State listed as endangered",
    model: false,
    text: "This group includes avian species that are listed by one or more states as endangered in their management plans. It includes the following species: American Oystercatcher, Black Skimmer, Black Tern, Common Tern, Forster Tern, Gull-billed Tern, Least Bittern, Least Tern, Piping Plover, Red Knot,and Roseate Tern. Note that not all listed species have data available. "
  },
  ambcchigh:{
    pName: "High conservation value by AMBCC",
    model: false,
    text: "This group includes the avian species in the highest tier in the Atlantic Marine Bird Conservation Cooperative (AMBCC) list of conservation priorities.  It includes the following species:  Common Eider, Common Loon, Gull-billed Tern, Harlequin Duck, Least Tern, Long-tailed Duck, Red-necked Pharalope, and Roseate Tern. Note that not all high priority species have data available. "
  }, 
  nersgcnhigh:{
    pName: "High conservation value by NE RSGCN",
    model: false,
    text: "This group includes species that are considered High or Very High value for conservation by the Northeast Fish & Wildlife Technical Committee. This includes the following species: American Black Duck, Least Tern, Piping Plover, Purple Sandpiper, Red Knot, Roseate Tern, and Saltmarsh sparrow. Note that not all high priority species have data available. "
  },  
  cormorants: {
    pName: "Cormorants",
    model: false,
    text: "This group includes the following species: Great Cormorant. Note that Double-crested Cormorant data are only available for offshore habitats. Also, there may be other species in this group that have no data available within our region. "
  },  
  dabblingducks: {
    pName: "Dabbling Ducks",
    model: false,
    text: "This group includes the following species: American Black Duck. Note that there may be other species in this group that have no data available within our region. "
  },  
  largewadingbirds:  {
    pName: "Large Wading Birds",
    model: false,
    text: "This group includes the following species: Least Bittern. Note that there may be other species in this group that have no data available within our region. "
  }, 
  landbasedshorebird:  {
    pName: "Land-based shorebirds",
    model: false,
    text: "This group includes the following species: American Oystercatcher, American Woodcock, Black-bellied Plover, Black-necked Stilt, Buff-breasted Sandpiper, Dunlin, Greater Yellowlegs, Killdear, Least Sandpiper, Lesser Yellowlegs, Long-billed Dowitcher, Marbled Godwit, Pectoral Sandpiper, Piping Plover, Purple Sandpiper, Red Knot, Ruddy Turnstone, Sanderling, Semipalmated Plover, Semipalmated Sandpiper, Solitary Sandpiper, Spotted Sandpiper, Stilt Sandpiper, Western Sandpiper, Whimbrel, Willet, Wilson Plover, and Wilson Snipe. Note that there may be other species in this group that have no data available within our region. "
  },  
  loons_grebes: {
    pName: "Loons & Grebes",
    model: false,
    text: "This group includes the following species: Common Loon, and Horned Grebe. Note that there may be other species in this group that have no data available within our region. "
  },   
  passerines: {
    pName: "Passerines & other small landbirds",
    model: false,
    text: "This group includes the following species: Eastern Meadowlark, Rusty Blackbird, and Saltmarsh Sparrow. Note that there may be other species in this group that have no data available within our region. "
  },   
  pharalopes:{
    pName: "Pharalopes",
    model: false,
    text: "This group includes the following species: Red-necked Pharalope. Note that the species Red Pharalope only has offshore data within our region. Also, there may be other species in this group that have no data available within our region. "
  },    
  seaducks_divingducks:{
    pName: "Seaducks & Diving Ducks",
    model: false,
    text: "This group includes the following species: Common Eider, Harlequin Duck, and Long-tailed Duck. Note that the following species only have offshore data within our region: Black Scoter, Red-breasted Merganser, Red-throated Loon, Surf Scoter, and White-winger Scoter. Also, there may be other species in this group that have no data available within our region. "
  },     
  terns_skimmers:{
    pName: "Terns & Skimmers",
    model: false,
    text: "This group includes the following species: Arctic Tern, Black Tern, Bridled Tern, Common Tern, Forster Tern, Gull-billed Tern, Least Tern, and Roseate Tern. Note that Royal Tern and Sooty Tern only have offshore data available within our region. Also, there may be other species in this group that have no model data available within our region. "
  },     
  collision: {
    pName:  "High collision sensitivity w. offshore wind",
    model: false,
    text: "This group includes avian species that are considered highly-sensitive to collision due to offshore wind energy projects on the Atlantic Continental Shelf. Group membership derived from BOEM OCS STUDY 2013-207 (Robinson Willmott et al. 2013). It includes the following species: Artic Tern, Band-rumped Storm Petrel, Bridled Tern, Common Eider, Common Loon,  Common Tern, Great Cormorant, Harlequin Duck, Horned Grebe, Red Pharalope, Red-necked Pharalope, and Roseate Tern. Note that there may be other species in this group that have no data available within our region.  Also, the following species only have offshore data within our region: Atlantic Puffin, Audubon Shearwater, Black Guillemot, Black Scoter, Black-legged Kittiwake, Common Murre, Cory Shearwater,  Double-crested Cormorant, Great Black-backed Gull, Great Shearwater, Great Skua, Herring Gull, Laughing Gull, Leach Storm Petrel, Long-tailed Duck, Manx Shearwater, Northern Fulmar, Northern Gannet, Parasitic Jaeger, Pomarine Jaeger, Razorbill, Red-brested Merganser, Red-throated Loon,  Sooty Shearwater, Sooty Tern, South Polar Skua, Surf Scoter, Thick-billed Murre, White-winged Scoter, and Wilson Storm Petrel."
  },   
  displacement: {
    pName:  "High displacement sensitivity w. offshore wind",
    model: false,
    text: "This group includes avian species that are considered highly-sensitive to displacement due to offshore wind energy projects on the Atlantic Continental Shelf. Group membership derived from BOEM OCS STUDY 2013-207 (Robinson Willmott et al. 2013). It includes the following species: Arctic Tern, Black Scoter, Common Eider, Common Loon, Great Cormorant, Long-tailed Duck, and Roseate Tern. Note that there may be other species in this group that have no data available within our region. Also, the following species only have offshore data available: Atlantic Puffin,  Black Guillemot, Bridled Tern, Common Murre, Common Tern, Great Black-backed Gull, Manx Shearwater, Northern Gannet, Razorbill, Red-throated Loon, Sooty Tern, Surf Scoter, Thick-billed Murre, and White-winged Scoter."
  },   
  birdDial:{
    pName: "Bird Relative Diversity Dials",
    model: false,
    text: "These dials are based on diversity values for the area of study compared to the ecoregional averages. Diversity values are calculated by adding the number of species that have yearly estimated abundances beyond the 'Very high' threshold (90th percentile). The reference values for the ecoregions are the following (mean|st. deviation): Gulf of Maine (3.1|3.12); Virginian (3.21|3.52).  "
  },
  pHigh: {
    pName: "Percent Very High",
    model: false,
    text: "This value shows the percent of the area that is above the 'High' threshold (>75th percentile)"
  }

})
onMounted(() => {
    if (activeLayerID.value != spLayer.value){
        loadDataByID(spLayer.value, version)
    }
})

</script>
<style scoped>

.highlight{
    /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
    border: 1px solid #aeaeae;
    margin: 3px;
    border-radius: 3px;
    position: relative;
    z-index: 10;
    /* margin-right: 3px; */
    /* padding-bottom:0px; */
    min-height: 12px !important; 
}
.bar-row{
    max-height: 19px;
    /* overflow: hidden; */
}
.dial-container{
    max-width: 200px;
}
.bar-rows-container{
    padding: 5px;
    max-height: 250px;
    overflow: auto;
    outline: none; /* Remove default focus outline */
}
.bar-rows-container:focus {
  outline: 2px solid #24302b; /* Add custom focus outline */
}


.mapActive{
    background-color: #1D8177;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.time-table-container{
    max-width: 500px;
}
.tab-container{
    border-radius: 3px;
    border: 1px solid #aeaeae;
}
.secondary-dropdown{
    border: 1px solid #1D8177;
    border-radius: 5px;
    min-height:70px;
    font-size: small;
}
.map-descr-row{
    background-color: #F1FDFC;
}
.circle{
    border-radius:50%;
}
</style>